import React, { memo, useCallback } from 'react'

import { Cube, Icon, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { removeStyle } from 'Pods/ThreeDStudio/Store/actions/renderSettings'
import { closeStylePanel, openStylePanel } from 'Pods/ThreeDStudio/Store/actions/ui'
import { MAX_RENDER_STYLES } from 'Pods/ThreeDStudio/Store/constants'

import SelectedStyle from './Components/SelectedStyle/SelectedStyle'

const emptyStyleIcon = <Icon svgComponent={Cube} size={iconSizeMedium} color="dark" notSpaced />

function StyleField() {
  const t = useTranslation()
  const styles = useThreeDStudioStore(state => state.renderSettings.styles)
  const isStylePanelOpen = useThreeDStudioStore(state => Boolean(state.ui?.isStylePanelOpen))
  const canAddStyle = styles.length < MAX_RENDER_STYLES
  const addSlotLabelKey = styles.length > 0
    ? 'viewerSidebar.enhance.render.styleAdd'
    : 'viewerSidebar.enhance.render.styleNone'

  const handleClick = useCallback(() => {
    if (isStylePanelOpen) {
      closeStylePanel()

      return
    }

    openStylePanel()
  }, [isStylePanelOpen])

  return (
    <div className="render-tab__field" role="group" aria-labelledby="render-style-label">
      <span className="render-tab__label-row">
        <span id="render-style-label" className="render-tab__label cgt-body-base-semibold">
          {t('viewerSidebar.enhance.render.styleLabel')}
        </span>
        <span className="render-tab__label-hint cgt-caption">
          {t('viewerSidebar.enhance.render.styleLimit', { max: MAX_RENDER_STYLES })}
        </span>
      </span>
      {styles.map(style => (
        <SelectedStyle
          key={style.id}
          style={style}
          isStylePanelOpen={isStylePanelOpen}
          onTogglePanel={handleClick}
          onRemove={removeStyle}
        />
      ))}
      {canAddStyle && (
        <button
          type="button"
          aria-expanded={isStylePanelOpen}
          className={classnames(
            'render-tab__style-field',
            isStylePanelOpen && 'render-tab__style-field--active',
          )}
          onClick={handleClick}
        >
          <span className="render-tab__style-thumb render-tab__style-thumb--empty" aria-hidden="true">
            {emptyStyleIcon}
          </span>
          <span className="render-tab__style-name cgt-body-base-semibold">
            {t(addSlotLabelKey)}
          </span>
        </button>
      )}
    </div>
  )
}

export default memo(StyleField)
